import React, { useEffect, useRef, useState } from "react";
import TextInput from "../Components/TextInput";
import Button from "../Components/Button";
import ReCAPTCHA from "react-google-recaptcha";
import { verifyMobileNumber } from "../API/requests";

const MobileNumberPage = ({
  setPageState,
  onResRecieve,
  mobileNumber,
  onMobileNumberChange,
  setIsLoading,
}) => {
  const siteKey = "6Le0VcsZAAAAAEZWgas8l-YDGPtHWIgsSglshEwU";
  const [captchaValue, setCaptchaValue] = useState(null);
  const captchaRef = useRef(null);
  const onCaptchaChange = (value) => setCaptchaValue(value);

  const clickHandler = (e) => {
    e.preventDefault();
    if (checkDisabled()) return;
    setIsLoading(true);
    verifyMobileNumber(mobileNumber, captchaValue)
      .then((res) => {
        onResRecieve(res);
        setPageState("OTP");
      })
      .catch((e) => {
        onResRecieve(e.response.data);
      })
      .finally(() => {
        setCaptchaValue(null);
        captchaRef.current.reset();
      });
  };
  const numericValueChangeHandler = (name, value) => {
    if (value) value = value.replace(/\D/g, "");
    onMobileNumberChange(value);
  };
  const checkDisabled = () => {
    if (!mobileNumber) return true;
    if (mobileNumber.length === 11 && captchaValue) return false;
    return true;
  };

  return (
    <>
      <div className="page-desc">لطفا شماره موبایل خود را وارد کنید</div>
      <div className="text-and-label">
        <div className="text-label">شماره موبایل</div>
        <div className="text-input-box">
          <TextInput
            placeholder="مثال: ...09"
            kind="mobileNumber"
            value={mobileNumber}
            autoFocus
            onChange={numericValueChangeHandler}
          />
        </div>
      </div>
      <ReCAPTCHA
        ref={captchaRef}
        className="recaptcha"
        hl="fa"
        sitekey={siteKey}
        onChange={onCaptchaChange}
      />
      <Button
        type="submit"
        disabled={checkDisabled()}
        onClick={clickHandler}
        text="تایید"
        variant="contained"
      />
    </>
  );
};

export default MobileNumberPage;
